import {
  CometChatUIKit,
  UIKitSettingsBuilder,
} from '@cometchat/chat-uikit-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import { COMETCHAT_CONSTANTS } from './AppConstants.ts';
import './tokens.css';
import './index.css';
import { initTheme, nextTheme } from './utils/theme-switcher';

initTheme();

// Shift+Alt+T — Cycle through themes (global, always active)
document.addEventListener('keydown', (e: KeyboardEvent) => {
  if (e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && e.code === 'KeyT') {
    e.preventDefault();
    nextTheme();
  }
});

const appID: string = COMETCHAT_CONSTANTS.APP_ID;
const region: string = COMETCHAT_CONSTANTS.REGION;
const authKey: string = COMETCHAT_CONSTANTS.AUTH_KEY;

if (appID && region && authKey) {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(appID)
    .setRegion(region)
    .setAuthKey(authKey)
    .subscribePresenceForAllUsers()
    .setAdminHost(
      `${COMETCHAT_CONSTANTS.APP_ID}.api-${COMETCHAT_CONSTANTS.REGION}.${COMETCHAT_CONSTANTS.IS_STAGING ? 'cometchat-staging.com' : 'cometchat.io'}/v3.0`,
    )
    .setClientHost(
      `${COMETCHAT_CONSTANTS.APP_ID}.apiclient-${COMETCHAT_CONSTANTS.REGION}.${COMETCHAT_CONSTANTS.IS_STAGING ? 'cometchat-staging.com' : 'cometchat.io'}/v3.0`,
    )
    .build();

  CometChatUIKit.init(uiKitSettings)?.then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    );
  });
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
}
